/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Academic_Title_LabelInputs */

const en_company_profile_academic_title_label = /** @type {(inputs: Company_Profile_Academic_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected academic degree`)
};

const de_company_profile_academic_title_label = /** @type {(inputs: Company_Profile_Academic_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erwarteter Studienabschluss`)
};

/**
* | output |
* | --- |
* | "Expected academic degree" |
*
* @param {Company_Profile_Academic_Title_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_academic_title_label = /** @type {((inputs?: Company_Profile_Academic_Title_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Academic_Title_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_academic_title_label(inputs)
	return en_company_profile_academic_title_label(inputs)
});